import React, { createContext, useContext, useMemo } from "react";
import type { EmailsThemeDto } from "@babackapp/private-api-client/types";

interface BlockThemeContextType {
	theme: EmailsThemeDto | null;
}

const BlockThemeContext = createContext<BlockThemeContextType | undefined>(undefined);

interface BlockThemeProviderProps {
	theme: EmailsThemeDto | null;
	children: React.ReactNode;
}

export function BlockThemeProvider({ theme, children }: BlockThemeProviderProps) {
	const values = useMemo(() => ({ theme }), [theme]);

	return (
		<BlockThemeContext.Provider value={values}>
			{children}
		</BlockThemeContext.Provider>
	);
}

export function useBlockThemeContext(): BlockThemeContextType {
	const context = useContext(BlockThemeContext);
	if (context === undefined) {
		throw new Error("useBlockThemeContext must be used within a BlockThemeProvider");
	}
	return context;
}
